<div class="hiperio-registration-config-list-container">
  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU</th>
      <td mat-cell *matCellDef="let element">

        <a *ngIf="(userPermissions | async)?.hiperio.read" class="default-link" [routerLink]="['/ofwca/hiperio/szczegoly/', element.id]"> {{element?.insuranceCompany?.name}}</a>
        <p *ngIf="!(userPermissions | async)?.hiperio.read"> {{element?.insuranceCompany?.name}}</p>
        <span *ngIf="element.productId === '5c1b128c-3cf4-4bc8-b5e1-a5a324173b1e'"> (HDI)</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA</th>
      <td mat-cell *matCellDef="let element">
        {{element.ofwca.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwcaRegistration">
      <th mat-header-cell *matHeaderCellDef> OFWCA Rejestracji</th>
      <td mat-cell *matCellDef="let element">
        {{element.registration?.ofwca?.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma</th>
      <td mat-cell *matCellDef="let element">
        {{element.registration?.contract?.company?.name}}
      </td>
    </ng-container>


<!--    <ng-container matColumnDef="name">-->
<!--      <th mat-header-cell *matHeaderCellDef> Nazwa</th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        {{element.name}}-->
<!--      </td>-->
<!--    </ng-container>-->

<!--    <ng-container matColumnDef="ofwca">-->
<!--      <th mat-header-cell *matHeaderCellDef> OFWCA</th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca?.fullName ? element.ofwca?.fullName : ""}}</a>-->
<!--      </td>-->
<!--    </ng-container>-->

<!--    <ng-container matColumnDef="contactDetails">-->
<!--      <th mat-header-cell *matHeaderCellDef> Dane kontaktowe </th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        {{element.firstName}}<br>-->
<!--        {{element.lastName}}<br>-->
<!--        {{element.email}}<br>-->
<!--        {{element.phone}}-->
<!--      </td>-->
<!--    </ng-container>-->

<!--    <ng-container matColumnDef="status">-->
<!--      <th mat-header-cell *matHeaderCellDef> Status</th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>-->
<!--      </td>-->
<!--    </ng-container>-->

<!--    <ng-container matColumnDef="concludeDate">-->
<!--      <th mat-header-cell *matHeaderCellDef> Data utworzenia</th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        {{element.createdAt | date:'y-MM-dd'}}-->
<!--      </td>-->
<!--    </ng-container>-->

<!--    <ng-container matColumnDef="action">-->
<!--      <th mat-header-cell *matHeaderCellDef></th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        <button *ngIf="(userPermissions | async)?.partner.admin_root && element.status.key === AFFILIATE_CODE_STATUS_ACTIVE" [disabled]="!(userPermissions | async)?.partner.admin_root" (click)="delete(element)" mat-icon-button color="warn"><mat-icon>delete</mat-icon> </button>-->
<!--        <button *ngIf="(userPermissions | async)?.partner.admin_root && element.status.key === AFFILIATE_CODE_STATUS_INACTIVE" [disabled]="!(userPermissions | async)?.partner.admin_root" (click)="restore(element)" mat-icon-button color="accent"><mat-icon>restore_from_trash</mat-icon> </button>-->

<!--      </td>-->
<!--    </ng-container>-->


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>
